export default {"src":"/pro/_next/static/media/wif.a7cbef6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};